<template>
    <div class="signUpPage" ref="pageCon">
        <div class="title">
            <div class="titleText">{{$t('language.exhibitionSign')}}</div>
            <div class="titleLine"></div>
        </div>
        <div class="content">
            <div class="prompt" v-html="introInfo"></div>
            <div class="listCon">
                <div class="listItem" v-for="(item,index) in listInfo" :key="index">
                    <div class="titleItem">{{item.title}}</div>
                    <div class="downLoad" @click="downLoad(item.id)">{{$t('language.downLoad')}}</div>
                </div>
            </div>
        </div>
        <div style="height:20px;"></div>
       <div class="footer">
       	<div class="footerCon"  ref="footerCon" >
			<div style="padding-top: 5px;padding-bottom: 5px;"><a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 36px;'><img src='../../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a></div>
       	    <div class="address"><div>地址: {{address}}</div></div>
       	    <div class="email"><div>邮箱:{{email}}</div></div>
       		<div class="email"><div>ICP备：晋ICP备13002558号-2</div></div>
       	</div>
       </div>
        <Fixed :goTop="gotoT"></Fixed>
    </div>
</template>
<script>
import Fixed from '../../components/fixed.vue';
export default {
    name:'signUp',
    data(){
        return{ 
           listInfo:[],
           introInfo:'',
		   address:'',
		   email:''
        }
    },
    components:{
       Fixed
    },
	created() {
		this.$fetch('/index/info').then(res => {
			this.address = res.data.address;
			this.email = res.data.email;
		})
	},
    mounted(){
        // 侧边菜单显示
        let fixCon = document.getElementsByClassName("fixed")[0]; 
        fixCon.style.opacity = "1";

        this.getInfo();
        this.getIntro();
    },
    methods:{
       // 获取初始化数据
       getInfo(){
        this.$fetch('Content/tableList').then(res => {
            if(res.code == 200){
                this.listInfo = res.data
            }
        })
      },
      getIntro(){
        this.$fetch('Content/getApplyInstruction').then(res => {
            if(res.code == 200){
                this.introInfo = res.data.info;
            }
        })
      },
      downLoad(id){
        window.location.href = this.axios.defaults.baseURL + "/Content/down/id/" + id 
      },
       // 顶部
       gotoT(){
          this.$refs.pageCon.scrollTop = 0;
       }
    }
}
</script>
<style scoped>
.signUpPage{
    font-family: Microsoft YaHei;
    height: 80vh;
    overflow: auto;
}
.title{
    margin:38px 0px 40px 191px;
    text-align: left;
}
.titleText{
    font-size: 42px;
    font-weight: bold;
    color: #000000;
    padding-bottom: 14px;
}
.titleLine{
    width: 53px;
    height: 6px;
    background: #000000;
}
.content{
    padding:0px 323px;
    height: 500px;
}
.prompt{
    font-size: 16px;
    font-weight: 400;
    color: #100F0F;
    line-height: 26px;
    margin-bottom: 50px;
}
.listCon{
   /* display: flex;
    flex-wrap: wrap; */
}
.listItem{
    width: 256px;
/*    display: flex;
    flex-direction: column; */
    /* align-items: center; */
    /* margin-right: 150px; */
	margin-left: 20px;
    padding-bottom: 50px;
	text-align: center;
	float: left;
    /* justify-content: space-between; */
}
.listItem:nth-of-type(3n + 3){
    margin-right: 0px;
}
.titleItem{
    width: 100%;
    height: 55px;
    font-size: 20px;
    font-weight: 400;
    color: #141212;
    line-height: 30px;
    text-align: center;
    margin-bottom: 20px;
    display:-webkit-box;
	-webkit-box-orient:vertical;
	-webkit-line-clamp:2;
	overflow:hidden;  
	text-overflow:ellipsis; 
}
.downLoad{
    width: 200px;
    height: 48px;
    background: #AF011A;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
	margin: 0 auto;
}
.footer{
	width: 100%;
	height: 42px;
	background: rgba(245, 245, 245, 1);
	position: absolute;
	bottom: 0%;
	left:0%;
}

.footerCon{
    width: 45%;
    height: 42px;
    background: rgba(245, 245, 245, 1);
    position: absolute;
    bottom: 0%;
    left:0%;
	right: 0;
	margin: auto;
    font-size: 14px;
    font-weight: bold;
    color: #3D3D3B;
    display: flex;
    justify-content: space-around;
}
@media screen and (max-width:1600px){
	.footerCon{
		width: 63%!important;
	}
}
@media screen and (max-width:1300px){
	.footerCon{
		width: 60%!important;
	}
}
@media screen and (max-width:900px){
	.footerCon{
		width: 70%!important;
	}
}
.footerCon>div{
    display: flex;
    align-items: center;
}
.address{
    margin-right: 100px;
}
.address img{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.email img{
    width: 19px;
    height: 14px;
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPage/signUp.vue